// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v1/extra.proto (package financial.emitten.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { FRAttributes } from "./fr_pb.js";

/**
 * ExtraAttributes used to return extra attributes of each company type
 * because each company type has different attributes
 * e.g for Stock, they have Price while for Mutual Fund, they have NAV
 * This is to prepare for future company type that has different attributes (scalable)
 *
 * @generated from message financial.emitten.entity.v1.ExtraAttributes
 */
export const ExtraAttributes = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v1.ExtraAttributes",
  () => [
    { no: 1, name: "fr_attributes", jsonName: "fr_attributes", kind: "message", T: FRAttributes, oneof: "extra" },
  ],
);

